import { __read } from "tslib";
import * as u from './urx';
import { propsReadySystem } from './propsReadySystem';
import { domIOSystem } from './domIOSystem';
import { listStateSystem } from './listStateSystem';
export var initialScrollTopSystem = u.system(function (_a) {
    var _b = __read(_a, 3), didMount = _b[0].didMount, scrollTo = _b[1].scrollTo, listState = _b[2].listState;
    var initialScrollTop = u.statefulStream(0);
    u.subscribe(u.pipe(didMount, u.withLatestFrom(initialScrollTop), u.filter(function (_a) {
        var _b = __read(_a, 2), offset = _b[1];
        return offset !== 0;
    }), u.map(function (_a) {
        var _b = __read(_a, 2), offset = _b[1];
        return ({ top: offset });
    })), function (location) {
        u.handleNext(u.pipe(listState, u.skip(1), u.filter(function (state) { return state.items.length > 1; })), function () {
            requestAnimationFrame(function () {
                u.publish(scrollTo, location);
            });
        });
    });
    return {
        initialScrollTop: initialScrollTop,
    };
}, u.tup(propsReadySystem, domIOSystem, listStateSystem), { singleton: true });
